import { topicCloud, trendTags } from '@/mocks/homeNews';
import SectionHeading from './SectionHeading';

const trendIcon: Record<string, string> = {
  up: 'ri-arrow-up-line text-primary-600',
  down: 'ri-arrow-down-line text-secondary-600',
  flat: 'ri-subtract-line text-foreground-400',
};

export default function TrendingTags() {
  return (
    <section id="trending" className="w-full bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
        <SectionHeading
          kicker="Tracking Board"
          title="热搜追踪榜"
          desc="把分散在各平台的讨论收拢成一张追踪榜，热度越高越靠前，方便顺着线索继续往下查。"
        />

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5 md:gap-6">
          <div className="lg:col-span-7 rounded-lg border border-background-200 bg-background-100 overflow-hidden">
            <div className="flex items-center justify-between px-5 md:px-6 py-4 border-b border-background-200">
              <span className="text-[13px] font-semibold text-foreground-900">实时热度榜</span>
              <span className="text-[12px] text-foreground-500">每小时更新</span>
            </div>
            <ul>
              {trendTags.map((tag, idx) => (
                <li
                  key={tag.name}
                  className="flex items-center gap-4 px-5 md:px-6 py-3.5 border-t border-background-200 first:border-t-0 hover:bg-background-50 transition-colors"
                >
                  <span
                    className={`flex items-center justify-center w-7 h-7 rounded-md text-[13px] font-bold shrink-0 ${
                      idx < 3
                        ? 'bg-primary-600 text-background-50'
                        : 'bg-background-200 text-foreground-600'
                    }`}
                  >
                    {idx + 1}
                  </span>
                  <a
                    href="#latest"
                    className="flex-1 text-[14px] text-foreground-900 hover:text-primary-700 transition-colors truncate"
                  >
                    {tag.name}
                  </a>
                  <span className="flex items-center gap-2 shrink-0">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className={`${trendIcon[tag.trend]} text-[15px]`} />
                    </span>
                    <span className="text-[13px] font-semibold text-foreground-700 tabular-nums">
                      {tag.heat}
                    </span>
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-5 flex flex-col gap-5">
            <div className="rounded-lg border border-background-200 bg-accent-50 p-5 md:p-6">
              <h3 className="font-heading text-[17px] font-bold text-foreground-950 flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-price-tag-3-line text-[16px] text-accent-700" />
                </span>
                话题标签云
              </h3>
              <p className="mt-2 text-[13px] text-foreground-600">
                点击标签可继续追踪相关线索与历史时间线。
              </p>
              <div className="mt-4 flex flex-wrap gap-2">
                {topicCloud.map((tag) => (
                  <a
                    key={tag}
                    href="#latest"
                    className="text-[12px] text-foreground-800 bg-background-50 border border-accent-200 px-3 py-1.5 rounded-full hover:bg-accent-100 hover:text-accent-900 transition-colors"
                  >
                    #{tag}
                  </a>
                ))}
              </div>
            </div>

            <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6 flex-1">
              <h3 className="font-heading text-[17px] font-bold text-foreground-950">追踪数据速览</h3>
              <div className="mt-4 grid grid-cols-2 gap-4">
                <div className="rounded-md bg-background-50 border border-background-200 p-4">
                  <div className="text-[12px] text-foreground-500">在追事件</div>
                  <div className="mt-1 font-heading text-[24px] font-bold text-foreground-950">8</div>
                </div>
                <div className="rounded-md bg-background-50 border border-background-200 p-4">
                  <div className="text-[12px] text-foreground-500">今日新进展</div>
                  <div className="mt-1 font-heading text-[24px] font-bold text-primary-600">26</div>
                </div>
                <div className="rounded-md bg-background-50 border border-background-200 p-4">
                  <div className="text-[12px] text-foreground-500">反转次数</div>
                  <div className="mt-1 font-heading text-[24px] font-bold text-accent-700">5</div>
                </div>
                <div className="rounded-md bg-background-50 border border-background-200 p-4">
                  <div className="text-[12px] text-foreground-500">涉及品牌</div>
                  <div className="mt-1 font-heading text-[24px] font-bold text-secondary-700">12</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}